/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { feedbackPost } from '../fn/feedback-resource/feedback-post';
import { FeedbackPost$Params } from '../fn/feedback-resource/feedback-post';

@Injectable({ providedIn: 'root' })
export class FeedbackResourceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `feedbackPost()` */
  static readonly FeedbackPostPath = '/feedback';

  /**
   * Submit Feedback.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `feedbackPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  feedbackPost$Response(
    params: FeedbackPost$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<void>> {
    const obs = feedbackPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Submit Feedback.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `feedbackPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  feedbackPost(
    params: FeedbackPost$Params,
    context?: HttpContext,
  ): Observable<void> {
    const resp = this.feedbackPost$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }
}
